import React, {useState, useRef, useLayoutEffect, useContext} from "react";
import {Button, HStack, Text, CloseButton, Flex} from "@chakra-ui/react";
import {lightFormat} from "date-fns";
import {TruncatedTextWithTooltip} from "./TruncatedTextWithTooltip";
import {MdLocationOn} from "react-icons/md";
import ApptType from "./ApptType";
import {crud} from "../../../crudRequests";
import {useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {isoToApptDate} from "../../../additional_files/helpers";

import ProductsInformation from "./ProductsInformation";
import {
  useToast,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverHeader,
  PopoverBody,
  Box,
} from "@chakra-ui/react";
import {BsPersonCircle, BsClock} from "react-icons/bs";
import {MdModeEditOutline} from "react-icons/md";
import {FaAward, FaEdit, FaWalking, FaEyeSlash} from "react-icons/fa";
import RescheduleAppointment from "./ApptRescheduleModal";
import {SocketContext} from "../../Layout";
import {getJitsiJWT} from "../helpers/jitsiFunctions";
import {getPatientMeetingLink} from "../helpers/getPatientMeetingLink";

import MeetingLinks from "./MeetingLinks";

import {useWindowDimensions} from "../../../additional_files/custom";
import {
  TbCalendarStats,
  TbCalendarCheck,
  TbCalendarOff,
  TbCalendarCog,
} from "react-icons/tb";
import {PatientBalancesModalWithoutProducts} from "./PatientBalancesModal";
const weekday = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

export const MembershipBadge = ({
  patient,
  schState,
  handleBrowseToTab,
  isOpen,
  onClose,
  onToggle,
}) => {
  const navigate = useNavigate();
  const activeMemberships = patient?.memberships?.filter(
    (membership) => membership.status !== "Cancelled"
  );

  return (
    <Popover key={patient?.pid} isOpen={isOpen} onClose={onClose}>
      <PopoverTrigger>
        <Button
          bg="transparent"
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          _hover={{bg: "transparent"}}
          mr={-2}
          p={1}
          h="fit-content"
          w="1rem"
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
        >
          <FaAward
            className="cursor-pointer bg-transparent text-[1.2rem]"
            style={{
              color: activeMemberships?.length > 0 ? "orange" : "gray",
            }}
          />
        </Button>
      </PopoverTrigger>
      <Box zIndex="popover">
        <PopoverContent width="200px" fontSize="sm">
          <PopoverArrow />
          <PopoverHeader fontSize="md" textColor="black">
            <HStack
              w="100%"
              display="flex"
              direction="row"
              gap={1}
              onClick={() => {
                if (handleBrowseToTab) {
                  handleBrowseToTab(14);
                } else {
                  navigate(`/patients`, {
                    state: {
                      ...schState,
                      selectedPid: patient?.pid,
                      navigateToTab: 16,
                    },
                  });
                }
              }}
              style={{cursor: "pointer"}}
            >
              <Text>
                {activeMemberships?.length > 0
                  ? "Active memberships"
                  : "Add Membership"}
              </Text>
              <FaEdit
                style={{
                  margin: "2px",
                  fontSize: "1rem",
                }}
              />
            </HStack>
          </PopoverHeader>
          <PopoverBody>
            <ul>
              {activeMemberships
                ?.filter((memb) => memb.active)
                .map((membership, index) => (
                  <li key={index} style={{color: "black"}}>
                    {membership.name}
                  </li>
                ))}
            </ul>
          </PopoverBody>
        </PopoverContent>
      </Box>
    </Popover>
  );
};

export default function AppointmentModal({dispatch, schState}) {
  const {width} = useWindowDimensions();
  const [isMembOpen, setIsMembOpen] = useState(false);
  const navigate = useNavigate();
  const [showCancellationModal, setShowCancellationModal] = useState(false);
  const [cancellationModalData, setCancellationModalData] = useState({
    title: "",
    status: "",
  });

  const [amountModal, setAmountModal] = useState(false);
  const [currentTime, setCurrentTime] = useState();
  const [sendingAidClaim, setSendingAidClaim] = useState();
  const apptModalRef = useRef(null);
  const [currentApptLink, setCurrentApptLink] = useState();
  const [right, setRight] = useState(`-448px`);
  const [hideList, setHideList] = useState(`100%`);
  const socket = useContext(SocketContext);

  const toast = useToast();
  const [insurer, setInsurer] = useState(null);
  const [currentAppt, setCurrentAppt] = useState(schState.selectedAppointment);
  const [patient, setPatient] = useState(schState.patient);
  let currentPatientName = `${patient.lName}, ${patient.fName}`;
  let identifier = currentAppt;

  let index = schState.doctorsIndexMap[identifier?.did];
  let clinician = schState.doctors[index];

  useEffect(() => {
    const fetchData = async (appt) => {
      try {
        const response = await crud(schState, [
          {
            db: schState.db,
            collection: "appointments",
            parameters: [{aid: appt?.aid}],
            method: "findOne",
          },
          {
            db: schState.db,
            collection: "patients",
            parameters: [{pid: appt?.pid}],
            method: "findOne",
          },
          {
            db: schState.db,
            collection: "insurers",
            parameters: [{iid: appt?.tpp}],
            method: "findOne",
          },
        ]);
        let {time} = appt.ISOdate
          ? isoToApptDate(appt)
          : {date: appt.date, time: appt.time};

        setCurrentTime(time);
        setCurrentApptLink(appt["clinicApptLink"]);
        const [data, patientData, insurerData] = response.data;
        setCurrentAppt(data);
        setPatient(patientData);
        setInsurer(insurerData);
      } catch (error) {
        console.error(error);
      }
    };
    if (schState.selectedAppointment) fetchData(schState.selectedAppointment);
    else setCurrentAppt(null);
  }, [schState.selectedAppointment]);

  const service = schState.services.find(
    (s) => s.serviceId === identifier?.serviceId
  );

  return (
    <section
      className=" h-full bg-[#F7FAFC] shadow-md  p-2 pt-0 px-4 pr-2  w-full  z-[999]"
      ref={apptModalRef}
      style={{
        opacity: 1,
      }}
      onClick={(e) => {
        e.stopPropagation();
        setIsMembOpen(false);
      }}
    >
      <Flex justifyContent="flex-end" p="2">
        <CloseButton
          color="#2D3748"
          onClick={() => {
            dispatch({type: "SELECT_APPOINTMENT", payload: null});
          }}
        />
      </Flex>
      {/* ChangeAmountModal removed — it edited amounts on the legacy `billing`
          row. Amounts live on the canonical order/plan. */}

      <div className="h-[calc(100vh-6rem)]   overflow-scroll p-2  sbar2">
        <div className="flex flex-col items-start space-y-1">
          <div className="flex items-end justify-between w-full pr-2">
            <div className="text-[#5754FF] text-[1.7rem] flex gap-1 items-center">
              <p className="font-semibold">
                {currentPatientName?.slice(0, 17) +
                  (currentPatientName?.length > 17 ? "..." : "")}
              </p>
              {/*<MembershipBadge
                  patient={patient}
                  schState={schState}
                  handleBrowseToTab={handleBrowseToTab}
                  isOpen={isMembOpen}
                  onClose={() => setIsMembOpen(false)}
                  onToggle={() => setIsMembOpen(!isMembOpen)}
                />*/}
              <span>with</span>
            </div>
          </div>
          {
            <div className="flex items-center p-0.5 rounded-md">
              {identifier?.assignedProfessional === "technician" ? (
                <p className="text-dark text-[1.2rem] leading-5 font-semibold">
                  {identifier?.technician || ""}
                </p>
              ) : (
                <>
                  <span className="flex justify-center h-10 items-center">
                    {clinician?.photo ? (
                      <img
                        src={clinician.photo}
                        alt=""
                        className="hover:cursor-pointer hover:bg-[] h-full rounded-md drop-shadow-lg"
                      />
                    ) : (
                      <BsPersonCircle className="text-[2.5rem] text-[#5754FF]/80" />
                    )}
                  </span>
                  <div className="ml-2 flex flex-col">
                    <p className="text-dark text-[16px] leading-5 font-semibold">
                      {`${clinician?.lastName}, ${clinician?.firstName}` || ""}
                    </p>
                    <span className="font-light text-[10px] text-dark">
                      {clinician?.accreditations}
                    </span>
                  </div>
                </>
              )}
            </div>
          }
        </div>

        {
          <DateComponent
            {...{time: currentTime, identifier, dispatch, schState, socket}}
          />
        }

        {
          <Status
            appt={identifier}
            patient={patient}
            {...{
              schState,
              dispatch,
              hideList,
              setHideList,
              socket,
              openCancellationModal: ({status, title}) => {
                setCancellationModalData({status, title});
                setShowCancellationModal(true);
              },
            }}
          />
        }
        <Services
          appt={identifier}
          {...{schState, dispatch, hideList, setHideList, socket, patient}}
        />
        {identifier && insurer && (
          <div className="space-y-1 mt-5">
            <p className="text-[#A1A1A1] text-xs">Third Party Payer</p>
            <div className="flex items-start space-x-1 relative">
              <div className="bg-[#97A1FF] leading-6 font-medium rounded-lg p-2 px-3 text-sm flex flex-col text-white relative w-full">
                <span>{insurer?.name || "N/A"}</span>
              </div>
            </div>
          </div>
        )}

        <PatientBalancesModalWithoutProducts
          patient={patient}
          state={schState}
          products={[]}
          services={schState.services}
        />
        <ProductsInformation appt={identifier} {...{schState, dispatch}} />
        {/* The legacy PaymentInformation block is gone: it read the legacy
            `billing` collection and charged cards through /executePayment.
            The patient pays from Account (/patient-app/billing/collect). */}
        <MeetingLinks
          appointment={identifier}
          state={schState}
          dispatch={dispatch}
        />
        <Button
          display={{base: "none", md: "block"}}
          w="full"
          size={"md"}
          variant={"outline"}
          bg={"transparent"}
          color={"#3D50FF"}
          borderColor={"#3D50FF"}
          borderWidth={"2px"}
          cursor={"pointer"}
          mb="6"
          mt="4"
          isDisabled={identifier?.cancelled || identifier?.noShow}
          onClick={(e) => {
            if (!identifier?.cancelled && !identifier?.noShow)
              setAmountModal(true);
          }}
        >
          Edit Appointment Details
        </Button>
      </div>

      <div className="absolute  bottom-3 flex w-full pl-1 pr-8">
        <button
          className=" flex-1 focus:outline-none justify-center flex space-x-2 items-center bg-[#3D50FF]/80 rounded-md p-1 px-3 w-full text-white whitespace-nowrap"
          onClick={async () => {
            const meetingLink = getPatientMeetingLink(identifier, patient?.pid);

            if (meetingLink) {
              let now = new Date();
              let apptDate = new Date(identifier.ISOdate);
              let before15min = new Date(apptDate.getTime() - 15 * 60000);
              let isIn15range = now >= before15min && now <= apptDate;
              let promise = new Promise(async (resolve, reject) => {
                try {
                  if (isIn15range)
                    await changeAppointmentStatus(
                      identifier,
                      "Arrived",
                      schState,
                      dispatch,
                      socket,
                      toast
                    );
                  if (identifier?.virtualMeeting?.platform === "jitsi") {
                    window.open(meetingLink, "_blank");
                  } else {
                    await getJitsiJWT(
                      schState,
                      identifier.aid,
                      patient?.pid,
                      schState.db,
                      clinician,
                      identifier.patientApptLink
                    );
                  }
                  resolve(null);
                } catch (error) {
                  console.error(error);
                  reject(error);
                }
              });

              toast.promise(promise, {
                success: {
                  title: "Authenticated",
                  description: "Successfully joined meeting!",
                },
                error: {
                  title: "Please try again",
                  description:
                    "Something wrong authenticating you to the meeting",
                },
                loading: {
                  title: "Authenticating...",
                  description: "Please wait",
                },
              });
            }
          }}
        >
          <span className="text-xs  h-6 w-6  flex justify-center items-center">
            <img alt="" src="/images/Doctor/video.png" className="w-[1.1rem]" />
          </span>
          <span className="font-medium text-sm ">Join Call</span>
        </button>
      </div>
    </section>
  );
}

function DateComponent({time, identifier: appt, dispatch, schState, socket}) {
  const [rescheduleRef, setRescheduleRef] = useState(false);
  const [date, setDate] = useState(null);
  const [duration, setDuration] = useState(null);

  useLayoutEffect(() => {
    if (appt) {
      setDate(new Date(appt.ISOdate));
      setDuration(appt.duration);
    }
  }, [appt]);

  let dateString = date?.toDateString();
  const organization = schState?.organization;
  const changeTime = organization?.allowPatientToChangeAppointmentDate || false;

  return (
    <div className=" w-full mt-6 flex justify-between items-start pr-2">
      <div className="">
        <div className="flex space-x-3 items-center relative w-full">
          <div>
            <p className="text-[#A1A1A1] text-xs  mb-1">booked for</p>
            <div className="rounded-lg overflow-hidden bg-[#E9E8FB] text-center">
              <p className="bg-[#6271FF] text-xs font-medium p-[2px] text-white">
                {weekday[date?.getDay() || 0]}
              </p>
              <p className="text-[#6271FF] font-bold text-lg px-5 py-1 space-x-1">
                <span>{dateString?.split(" ")[1]}</span>
                <span>{dateString?.split(" ")[2]}</span>
              </p>
            </div>
          </div>
          <div className="flex  relative items-start py-1">
            <p className="flex flex-col leading-3 font-semibold text-center text-xs bg-[#F6F5FE] rounded-t-lg pt-1 -mr-4 z-10">
              <span className="bg-[#6271FF]  w-16 rounded-full leading-4 text-white px-2 p-1 mb-0.5">
                {time?.toLowerCase() || ""}
              </span>
              <span className="text-[#6271FF] text-[10px]">
                {duration || ""}
              </span>
            </p>
            <p className="">
              <BsClock className="text-[#6271FF] text-[3rem] stroke-[0.1]" />
            </p>
            {!appt?.cancelled && !appt?.arrived && changeTime && (
              <p className="absolute top-[-12px] right-[-12px]">
                <span
                  className="hover:cursor-pointer text-[#A1A1A1] h-[1.5rem] w-[1.5rem] overflow-hidden group rounded-lg flex justify-center items-center drop-shadow-md"
                  onClick={() => {
                    setRescheduleRef(true);
                  }}
                >
                  <MdModeEditOutline />
                </span>
              </p>
            )}
          </div>
        </div>
        {appt?.appointmentType === "live" && appt?.address && (
          <div className="flex  items-center mt-4">
            <MdLocationOn className="text-[#3182ce]" />
            <div className="w-[12rem]">
              <TruncatedTextWithTooltip
                color={"blue.500"}
                w="full"
                fontSize={"sm"}
              >
                {appt?.appointmentType === "live" ? appt?.address || "" : ""}
              </TruncatedTextWithTooltip>
            </div>
          </div>
        )}
      </div>
      <ApptType full appt={appt} />

      {rescheduleRef && appt && (
        <RescheduleAppointment
          schState={schState}
          appointment={appt}
          stateChanger={setRescheduleRef}
          dispatch={dispatch}
          socket={socket}
        />
      )}
    </div>
  );
}

function Services({appt, schState, dispatch, hideList, patient, socket}) {
  const [service, setService] = useState(null);

  const membership = patient?.memberships?.find(
    (memb) => memb.uuid === appt?.paidByMembership
  );

  useLayoutEffect(() => {
    if (appt) {
      setService(appt.service);
    }
  }, [appt]);

  return (
    <div className="space-y-1 justify-between w-full">
      <div className="space-y-1 mt-5">
        <p className="text-[#A1A1A1] text-xs">service</p>
        <div className="flex items-start space-x-1 relative">
          <div className="bg-[#97A1FF] leading-6 font-medium rounded-lg p-2 px-3 text-sm flex text-white relative w-full items-center">
            <span
              className="inline-block w-[40%] whitespace-nowrap overflow-hidden overflow-ellipsis font-semibold mx-2"
              title={service}
            >
              {service}
            </span>
            {membership && (
              <div className="flex flex-col w-[60%] text-center text-xs mx-2">
                <span>Service included in membership:</span>
                <span
                  className="whitespace-nowrap overflow-hidden overflow-ellipsis"
                  title={membership.name}
                >
                  {membership.name}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function Status({appt}) {
  const [st, setSt] = useState("Unconfirmed");

  let colorsMap = {
    Unconfirmed: "#8F8CFF",
    Confirmed: "#5754FF",
    Rescheduled: "#FF9900",
    Arrived: "#2dd4bf",
    "No Show": "#000000",
    Cancelled: "#FF0000",
  };

  let statusMap = {
    noShow: "No Show",
    cancelled: "Cancelled",
    arrived: "Arrived",
    pConfirmed: "Confirmed",
    rescheduled: "Rescheduled",
  };
  function status(appt) {
    for (let [key, val] of Object.entries(statusMap)) {
      if (appt[key]) return val;
    }
    return "Unconfirmed";
  }

  useLayoutEffect(() => {
    appt && setSt(status(appt));
  }, [appt]);

  let statusIcon = {
    Unconfirmed: <TbCalendarStats className="text-[14px]" />,
    Confirmed: <TbCalendarCheck className="text-[14px]" />,
    Rescheduled: <TbCalendarCog className="text-[14px]" />,
    Arrived: <FaWalking className="text-[14px]" />,
    "No Show": <FaEyeSlash className="text-[14px]" />,
    Cancelled: <TbCalendarOff className="text-[14px]" />,
  };

  return (
    <div className="mt-6 space-y-1">
      <p className="text-[#A1A1A1] text-xs">status</p>
      <div className="w-full grid grid-cols-3 gap-2">
        {Object.keys(colorsMap)
          .filter((s) => s === st)
          .map((status, i) => (
            <CustomButton
              key={i}
              isSolid={st === status}
              bgColor={colorsMap[status]}
              isCursorPointer={false}
            >
              <HStack gap="1">
                <Text>{status}</Text>

                {statusIcon[status]}
              </HStack>
            </CustomButton>
          ))}
      </div>
    </div>
  );
}

async function changeAppointmentStatus(
  appt,
  status,
  schState,
  dispatch,
  socket,
  toast
) {
  let generatingToast = null;
  try {
    const restStatus = (status) => {
      switch (status) {
        case "No Show":
          return {cancelled: false, arrived: false};
        case "Cancelled":
          return {noShow: false, arrived: false};
        case "Arrived":
          return {noShow: false, cancelled: false};
        case "Confirmed":
          return {noShow: false, cancelled: false, arrived: false};
      }
    };

    let statusMap = {
      "No Show": "noShow",
      Cancelled: "cancelled",
      Arrived: "arrived",
      Confirmed: "pConfirmed",
      Rescheduled: "rescheduled",
    };

    if (appt?.aid && !appt[statusMap[status]]) {
      {
        /*generatingToast = toast({
          title: "Saving status",
          description: "The status for this appointment is being updated.",
          status: "loading",
          variant: "subtle",
          duration: null,
          isClosable: true,
        });*/

        const updateBody = {
          ...appt,
          [statusMap[status]]: true,
          ...restStatus(status),
        };

        if (status === "Confirmed") {
          let note = updateBody.note || "";
          let name = schState.doctor
            ? schState.doctor.name
            : schState.admin.name;
          let date = lightFormat(new Date(), "dd/MM/yyyy h:mm aaa");
          note += `${note && "\n"}Confirmed by ${name} at ${date}.`;
          updateBody.note = note;
        }

        let {_id, ...data} = updateBody;
        await crud(
          schState,
          [
            {
              db: schState.db,
              collection: "appointments",
              parameters: [{aid: data.aid}, {$set: data}],
              method: "updateOne",
            },
          ]
        );

        socket?.emit?.("update_appt", updateBody);

        // toast.close(generatingToast);
        dispatch({type: "UPDATE_APPOINTMENT", payload: updateBody});
        /*  toast({
          title: "The appointment has been successfully updated!",
          status: "success",
          duration: 3000,
          isClosable: true,
        });*/
      }
    }
  } catch (error) {
    //toast.close(generatingToast);
    /* toast({
      title: "Update error.",
      description: error.response?.data || error.message,
      status: "error",
      isClosable: true,
    });*/
    throw error;
  }
}

const CustomButton = ({
  isSolid,
  isCursorPointer = true,
  bgColor,
  onClick,
  children,
}) => {
  return (
    <Button
      size={"xs"}
      variant={isSolid ? "solid" : "outline"}
      bg={isSolid ? bgColor : "transparent"}
      color={isSolid ? "white" : bgColor}
      borderColor={bgColor}
      borderWidth={isSolid ? "0" : "2px"}
      //  onClick={() => isCursorPointer && onClick()}
      cursor={isCursorPointer ? "pointer" : "not-allowed"}
    >
      {children}
    </Button>
  );
};
